exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".InvitationOpenBox {\n  width: 100%;\n  min-height: 100vh;\n  background: #EE5E32 url(" + require("./image/BG.png") + ") no-repeat 0 0;\n  background-size: cover;\n  font-size: 0.14rem;\n  padding-bottom: 0.4rem;\n}\n.InvitationOpenBox img {\n  width: 100%;\n  display: block;\n}\n.InvitationOpenBox > div {\n  text-align: center;\n  margin-bottom: 0.1rem;\n  color: #fff;\n}\n.InvitationOpenBox > div > span {\n  color: #FCFF00;\n}\n.InvitationOpenBox .XC {\n  background: url(" + require("./image/XC.png") + ") no-repeat center center;\n  background-size: contain;\n  height: 0.5rem;\n  display: block;\n  margin: 0 auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/invitation/invitationOpen/index.less
// module id = 998
// module chunks = 0